module.exports = __webpack_public_path__ + "img/20201107_203914.9472be7b.jpg";